import { motion } from 'framer-motion'
import { CheckIcon } from '../../../assets/svgs/icons'
import styles from './styles.module.css'

export const StepSuccessWhatsapp = () => {
  const WPP_NUMBER = import.meta.env.VITE_WPP_NUMBER
  return (

    <motion.div
      initial={{ x: '100vw' }}
      animate={{ x: 0 }}
      exit={{ x: '-100vw' }}
      transition={{ type: 'tween', duration: 0.5 }}
      className={styles.pageWrapper}
    >
      <div className={styles.page}>
        <div className={styles.text_success_container}>
          <div className={styles.badge_check_icon}>
            <CheckIcon color='#fff'/>
          </div>
          <p>Confirmado</p>
        </div>
        <div className={styles.btn_text_container}>
          <p>O pagamendo foi Efetuado com sucesso!</p>
          <button onClick={()=>window.location.replace(`https://wa.me/${WPP_NUMBER}`)}>Retornar ao WhatsApp</button>
        </div>
      </div>
    </motion.div>
  )
}
